import React from 'react';
import './StatusBadge.css';

export function getStatusKey(siteqp, comVinculo) {
    const sit = (siteqp ?? '').toString().toUpperCase();
    if (sit === 'A' && comVinculo) return 'assigned';
    if (sit === 'A') return 'inStock';
    if (sit === 'M') return 'inMaintenance';
    if (['I', 'R', 'Q'].includes(sit)) return 'retired';
    return 'outro';
}

function StatusBadge({ siteqp, comVinculo }) {
    const status = getStatusKey(siteqp, comVinculo);
    const labels = {
        inStock: 'Em estoque',
        assigned: 'Atribuído',
        inMaintenance: 'Em manutenção',
        retired: 'Baixado',
        outro: 'Outro'
    };
    const label = labels[status] || labels.outro;
    return (
        <span className={`inventario-status-badge inventario-status-badge--${status}`} title={label}>
            {label}
        </span>
    );
}

export default StatusBadge;
